export default {
  'commissionmanagement.commissionmanagement': 'مدیریت امتیازات',
  'commissionmanagement.accountsnotify':
    'کاربر گرامی جهت مدیریت حساب های بانکی لطفا از طریق لینک ',
  'commissionmanagement.accountsnotify1': ' اقدام فرمایید.',
  'commissionmanagement.accountmanagement': 'مدیریت حساب های بانکی',
  'commissionmanagement.description': 'توضیحات',
  'commissionmanagement.bankaccount': 'شماره حساب',
  'commissionmanagement.save': 'ثبت',
  'commissionmanagement.addrequest': 'امتیاز به پول',
  'commissionmanagement.withdrawamount': 'امتیاز قابل برداشت',
  'commissionmanagement.index': 'ردیف',
  'commissionmanagement.requestdate': 'تاریخ درخواست',
  'commissionmanagement.requeststatus': 'وضعیت درخواست',
  'commissionmanagement.withdrawtype': 'نوع برداشت',
  'commissionmanagement.requestadd': 'درخواست برداشت با موفقیت ثبت گردید',
  'commissionmanagement.tryagain': 'لطفا مجددا تلاش نمایید',
  'commissionmanagement.deleterequest': 'حذف درخواست برداشت',
  'commissionmanagement.deleteerror': 'امکان حذف درخواست وجود ندارد',
  'commissionmanagement.disapprove': 'عدم تایید',
  'commissionmanagement.approve': 'تایید',
  'commissionmanagement.pending': 'درحال بررسی',
  'commissionmanagement.notpaid': 'عدم پرداخت',
  'commissionmanagement.paid': 'پرداخت',
  'commissionmanagement.showdetail': 'نمایش جزئیات',
  'commissionmanagement.incomedetail': 'جزئیات درآمد',
  'commissionmanagement.withdrawreport': 'گزارش تراکنش ها',
  'commissionmanagement.transferpoints': 'انتقال امتیاز',
  'commissionmanagement.transitional': 'نوع تراکنش',
  'commissionmanagement.buycard': 'خرید کارت شارژ',
  'commissionmanagement.buyCard': 'خرید کارت',
  'commissionmanagement.paybill': 'پرداخت قبض',
  'commissionmanagement.spendpoints': 'خرج امتیاز',
  'commissionmanagement.lottery': 'قرعه کشی',
  'commissionmanagement.earnpoints': 'کسب امتیاز',
  'commissionmanagement.redandantrequest':
    'یک درخواست درحال بررسی وجود دارد. امکان ارسال مجدد وجود ندارد',
  'commissionmanagement.exitfee': 'عوارض خروج از کشور',
  'commissionmanagement.exitTax': 'پرداخت عوارض',
  'commissionmanagement.requestreport': 'گزارش درخواست های برداشت',
  'commissionmanagement.phrase': 'شماره سند',
  'commissionmanagement.documentdescription': 'شرح سند',
  'commissionmanagement.transferamount': 'امتیاز قابل انتقال',
  'commissionmanagement.transfermoney': 'انتقال وجه',
  'commissionmanagement.pointamount': 'میزان امتیاز',
  'commissionmanagement.secondpassword': 'رمز دوم',
  'commissionmanagement.resecondpassword': 'تکرار رمز دوم',
  'commissionmanagement.transfererror':
    'میزان امتیاز درخواستی بیشتر از میزان امتیاز باقیمانده می باشد',
  'commissionmanagement.transfernotify':
    'جهت انتقال امتیاز ابتدا می بایست از طریق لینک ',
  'commissionmanagement.transfernotify1': ' اقدام فرمایید.',
  'commissionmanagement.addsecondpassword': 'ثبت رمز دوم',
  'commissionmanagement.wagenotify1': 'کاربر گرامی دقت داشته باشید، ',
  'commissionmanagement.wagenotify2':
    ' از امتیاز شما بابت کارمزد کسر می گردد.آیا موافق هستید؟',
  'commissionmanagement.errorsecondpassword':
    'رمز دوم ثبت نگردیده است. لطفا ابتدا رمز دوم را ثبت نمایید',
  'commissionmanagement.wrongsecondpassword': 'رمز دوم صحیح نمی باشد',
  'commissionmanagement.successtransfer': 'امتیاز با موفقیت انتقال یافت',
  'commissionmanagement.notenoughpoint':
    'امتیاز درخواست داده شده با توجه به میزان امتیاز معلق شما مجاز نمی باشد',
  'commissionmanagement.sameprofiles':
    'فرستنده و گیرنده امتیاز نمیتواند یکسان باشد',
  'commissionmanagement.InternalServer': 'خطای سرور داخلی',
  'commissionmanagement.deleteconfirm':
    'آیا از حذف درخواست برداشت امتیاز مطمئن هستید؟',
  'commissionmanagement.deletesucess': 'درخواست برداشت با موفقیت حذف گردید',
  'commissionmanagement.customer': 'مشتریان',
  'commissionmanagement.employee': 'کارمندان',
  'commissionmanagement.request': 'درخواست',
  'commissionmanagement.income': 'درآمد شما',
  'commissionmanagement.wallet': 'شارژ کیف پول',
  'commissionmanagement.customerregion': 'تعداد مشتریان به تفکیک ناحیه',
  'commissionmanagement.totalpoint': 'مجموع امتیاز',
  'commissionmanagement.requestprice': 'مبلغ درخواستی ( ریال )',
  'commissionmanagement.sendsms': 'ارسال پیامک',
  'commissionmanagement.requestpoint': 'امتیاز درخواستی',
  'commissionmanagement.wallettransaction': 'آخرین تراکنش های کیف پول',
  'commissionmanagement.recenttransactions': 'تراکنش های اخیر',
  'commissionmanagement.pointtransactions': 'تراکنش های امتیاز',
  'commissionmanagement.exitfeepayment': 'پرداخت عوارض',
  'commissionmanagement.moneydescription':
    'می توانید امتیازتان را به پول تبدیل و به حساب بانکی خود واریز نمایید.',
  'commissionmanagement.transferpointdescriptionTripsi':
    'از این طریق میتوانید امتیازتان را به کاربران تریپسی انتقال دهید.',
  'commissionmanagement.transferpointdescriptionTripord':
    'از این طریق میتوانید امتیازتان را به کاربران تریپ اُرد انتقال دهید.',
  'commissionmanagement.getpointdescription':
    'از راه های مختلف میتوانید امتیازتان را افزایش و سفرهای رایگان داشته باشید.',
  'commissionmanagement.spendpointdescription':
    'میتوانید امتیاز خود را در بخش های مختلف استفاده و خدمات رایگان داشته باشید.',
  'commissionmanagement.buycarddescription':
    'از طریق امتیاز میتوانید کارت شارژ همراه اول ، ایرانسل و تالیا رایگان دریافت نمایید.',
  'commissionmanagement.exitfeedescription':
    'با امتیاز خود میتوانید عوارض خروج از کشور را پرداخت نمایید.',
  'commissionmanagement.safeway': 'مطمئن ترین راه',
  'commissionmanagement.spendanywhere': 'خرج در هرجا',
  'commissionmanagement.deposit': 'واریز به حساب',
  'commissionmanagement.easyway': 'آسانترین راه',
  'commissionmanagement.fastway': 'سریعترین راه',
  'commissionmanagement.buypoint': 'شارژ امتیاز',
  'commissionmanagement.entersecondpassword': 'رمز دوم را وارد کنید',
  'commissionmanagement.usepoint': 'دوست عزیزم امتیاز را به خوبی استفاده کن',
  'commissionmanagement.textTransferpoints':
    'از طریق فرم زیر می توانید امتیاز خود را به حساب کاربری دیگری انتقال دهید .',
  'commissionmanagement.textRequest':
    'از طریق فرم زیر می توانید امتیاز خود را به پول تبدیل کنید .',
  'commissionmanagement.textDetails':
    'از طریق فرم زیر می توانید جزییات کاربر مورد نظر را مشاهده و یا ویرایش کنید .',
};
